<template>
  <BaseSideModal :width="'680px'" :show-footer="false" @close="close">
    <template #title>
      <span>{{ $t('carriers.import.ImportHistory') }}</span>
    </template>

    <!-- See AllUpdatesDrawer: a second line in the title slot overflows the
         modal, because its content height assumes a one-line header. -->
    <p class="account-history__subtitle">
      {{ account.label || account.username }}
      <span v-if="account.portalName">· {{ account.portalName }}</span>
    </p>

    <ImportRunList
      :runs="runs"
      :loading="loading"
    />
  </BaseSideModal>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseSideModal from '@/views/RenovaDashboard/components/ui-kit/BaseSideModal/BaseSideModal';
import ImportRunList from './ImportRunList';

/**
 * One portal account's import history.
 *
 * Its own window rather than a third section stacked under the credentials
 * form: settings and history answer different questions, and someone watching a
 * run finish should not have to scroll past a password field to see it.
 *
 * The runs come from the store, so the poll advances them while this is open.
 * The list it shows is the shared one, the same component All updates uses, so
 * the two cannot drift apart.
 */
export default {
  name: 'PortalAccountHistoryModal',
  components: { BaseSideModal, ImportRunList },
  props: {
    account: { type: Object, required: true },
  },
  emits: ['close'],
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapGetters(['carrierImportAccountRuns']),
    runs() {
      return this.carrierImportAccountRuns[this.account.scrapeAccountId] || [];
    },
  },
  created() {
    // Tell the store which account is on screen before fetching, so that if the
    // fetch lands on a live run the poll it starts already knows to keep this
    // list fresh too.
    this.$store.dispatch('carrierImportSetOpenAccount', this.account.scrapeAccountId);
    this.$store.dispatch('carrierImportFetchAccountRuns', this.account.scrapeAccountId)
      .finally(() => { this.loading = false; });
  },
  beforeDestroy() {
    this.$store.dispatch('carrierImportSetOpenAccount', null);
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.account-history__subtitle {
  font-size: 13px;
  font-weight: 400;
  color: var(--solid-dark-purple);
  margin-bottom: 12px;
}
</style>
